import React, { memo } from "react";

function Dot({ isActive, onClick, animationDuration, color }) {
  return (
    <span
      style={{
        borderRadius: "9999999px",
        width: isActive ? "50px" : "10px",
        height: "10px",
        backgroundColor: color,
        opacity: isActive ? 1 : 0.4,
        cursor: "pointer",
        transition: `width ${animationDuration || "1s"}`,
      }}
      role="button"
      title="Slider Dot"
      onClick={() => onClick()}
    />
  );
}

function DotControls({ arr, activeIndex, onClick, animationDuration, color }) {
  return (
    <div className="inline-flex items-center justify-center gap-2 p-1 max-w-fit flex-wrap">
      {(arr || []).map((item, index) => (
        <Dot
          key={index}
          isActive={index === activeIndex}
          animationDuration={animationDuration}
          color={color || "white"}
          onClick={() => {
            onClick && onClick({ clickedIndex: index });
          }}
        />
      ))}
    </div>
  );
}

export default memo(DotControls);
